import React from 'react';
import { useHistory, useLocation } from 'react-router';
import PropTypes from 'prop-types';

import Logo from '../../../../../Logo';
import { getAsset } from '../../../../../../../util/assets';
import getConfig from '../../../../../../../util/config';
import SearchIcon from '../../../../../../icons/SearchIcon';
import Button from '../../../../../Button';
import DropdownMenu from '../../../../../DropdownMenu';

const propTypes = {
  signupDisabled: PropTypes.bool,
  isProView: PropTypes.bool,
};

const Menu = ({ signupDisabled, isProView }) => {
  const history = useHistory();
  const location = useLocation();
  const { marcomUrl } = getConfig();

  const isSigningPage = location.pathname.endsWith('/signin');

  return (
    <nav className="marcom-layout-menu">
      <Logo
        logoSrc={getAsset(
          isProView ? '/waldo-logo-pro.svg' : '/waldo-logo.svg',
        )}
        linksTo={marcomUrl}
        externalLink
      />
      <DropdownMenu
        toggleClassName="nav-item"
        dropdownClassName="nav-item-dropdown"
        toggle="Personal"
        placement="bottom-start"
        closeOnClickWithin
      >
        <a href={`${marcomUrl}/everyday-sharing/?`}>Everyday sharing</a>
        <a href={`${marcomUrl}/special-events/?`}>Special events</a>
        <a href={`${marcomUrl}/slideshows/?`}>Smart slideshows</a>
        <a href={`${marcomUrl}/group-video/?`}>Group video</a>
        <a href={`${marcomUrl}/video-guestbook/?`}>Video guestbook</a>
        <a href={`${marcomUrl}/waldogram/?`}>Waldograms</a>
      </DropdownMenu>
      <DropdownMenu
        toggleClassName="nav-item"
        dropdownClassName="nav-item-dropdown"
        toggle="Business"
        placement="bottom-start"
        closeOnClickWithin
      >
        <a href="https://waldo.pro/" className="text-extra-bold text-primary">
          Pro photographers &ndash; Check out WaldoPro!
        </a>
        <hr className="my-2" />
        <a href={`${marcomUrl}/camps/`}>Camps</a>
        <a href={`${marcomUrl}/churches/`}>Churches</a>
        <a href={`${marcomUrl}/corporate/`}>Corporate</a>
        <a href={`${marcomUrl}/events/`}>Event organizers &amp; venues</a>
        <a href={`${marcomUrl}/greek/`}>Greek organizations</a>
        <a href={`${marcomUrl}/resorts/`}>Resorts & attractions</a>
        <a href={`${marcomUrl}/schools/`}>Schools</a>
        <a href={`${marcomUrl}/sports/`}>Youth sports</a>
      </DropdownMenu>
      <DropdownMenu
        toggleClassName="nav-item"
        dropdownClassName="nav-item-dropdown"
        toggle="Pricing"
        placement="bottom-start"
        closeOnClickWithin
      >
        <a href={`${marcomUrl}/pricing/?`}>Everyday sharing</a>
        <a href={`${marcomUrl}/pricing/special-events/?`}>Special events</a>
        <a href={`${marcomUrl}/pricing/business/?`}>Business</a>
      </DropdownMenu>
      <div className="marcom-layout-menu-call-to-actions">
        <Button btnStyle="link" href={`${marcomUrl}/search/?`}>
          <SearchIcon color="#0d84fe" className="mr-1" size={16} /> Find an
          event
        </Button>
        {!signupDisabled && (
          <DropdownMenu
            toggleClassName="nav-item"
            dropdownClassName="nav-item-dropdown"
            toggle="Sign up"
            placement="bottom-start"
            closeOnClickWithin
          >
            <Button
              btnStyle="reset"
              className="dropdown-item text-bold py-1"
              onClick={() => history.push(`/auth/register`)}
            >
              Business
            </Button>
            <Button
              btnStyle="reset"
              className="dropdown-item text-bold py-1"
              onClick={() => history.push(`/shutterbug/register`)}
            >
              Personal
            </Button>
          </DropdownMenu>
        )}
        {!isSigningPage && (
          <Button btnOutline onClick={() => history.push(`/shutterbug/signin`)}>
            Login
          </Button>
        )}
      </div>
    </nav>
  );
};

Menu.propTypes = propTypes;

export default Menu;
